import React, { Component } from 'react';
// import { withLeaflet, MapControl } from 'react-leaflet'; // Not available in v4
import L from 'leaflet';
import { OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch';

class GeoSearch extends Component {
  constructor(props, context) {
    super(props);
    this.leafletElement = null;
  }

  createLeafletElement(opts) {
    const provider = new OpenStreetMapProvider();
    const searchControl = new GeoSearchControl({
      provider: provider,
      style: 'button',
      showMarker: true,
      showPopup: true,
      autoClose: true,
      retainZoomLevel: false,
      animateZoom: true,
      keepResult: false,
      searchLabel: 'Search for a location',
    });
    return searchControl;
  }

  componentDidMount() {
    if (this.props.leaflet && this.props.leaflet.map) {
      this.leafletElement = this.createLeafletElement();
      const { map } = this.props.leaflet;
      map.addControl(this.leafletElement);

      const func = (e) => {
        var evt = e ? e : window.event;
        if (evt.stopPropagation) {
          evt.stopPropagation();
        } else {
          evt.cancelBubble = true;
        }
      };

      setTimeout(() => {
        var elements = document.getElementsByClassName(
          'leaflet-control-geosearch'
        );
        if (elements.length > 0) {
          elements[0].onclick = func;
          elements[0].ondblclick = func;
        }
      }, 100);
    }
  }

  componentWillUnmount() {
    if (this.leafletElement && this.props.leaflet && this.props.leaflet.map) {
      this.props.leaflet.map.removeControl(this.leafletElement);
    }
  }

  render() {
    return null;
  }
}

export default GeoSearch;
